// import Swiper JS
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

(function () {
  const allPostSlider = document.querySelectorAll(
    ".com-postlinks .swiper-container"
  );

  for (let i = 0; i < allPostSlider.length; i++) {
    const container = allPostSlider[i];
    const idInt = container.dataset.randomIdInt;
    const slidesPerView = container.dataset.slidesPerView;

    const conf = {
      // Optional parameters
      // loop: true,
      spaceBetween: 20,

      // If we need pagination
      pagination: {
        el: "#swiper-pagination-" + idInt,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: "#swiper-button-next-" + idInt,
        prevEl: "#swiper-button-prev-" + idInt,
      },
    };

    if (slidesPerView) {
      conf.slidesPerView = 1;
      conf.breakpoints = {
        460: {
          slidesPerView: slidesPerView - 1,
        },
        640: {
          slidesPerView: slidesPerView,
        },
      };
    }

    let postSwiper = new Swiper(container, conf);
  }
})();
